
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"15","fill":"red"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.049 4.15v8.566c0 1.014.883 1.836 1.973 1.836h5.92c1.09 0 1.974-.822 1.974-1.836V4.15H1.049zm2.633 8.473c0 .222-.148.403-.33.403h-.33c-.183 0-.33-.18-.33-.403v-6.85c0-.215.138-.386.311-.399h.367c.173.013.312.184.312.399v6.85zm2.96 0c0 .222-.147.403-.33.403h-.66c-.182 0-.33-.18-.33-.403v-6.85c0-.215.138-.386.311-.399h.697c.173.013.312.184.312.399v6.85zm2.63-6.85v6.85c0 .223-.147.403-.33.403h-.33c-.182 0-.33-.18-.33-.403v-6.85c0-.215.139-.386.312-.399h.366c.174.013.312.184.312.399zm1.644-4.07H1.049c-.364 0-.658.274-.658.612v.306c0 .338.294.612.658.612h9.867c.363 0 .657-.274.657-.612v-.306c0-.338-.294-.612-.657-.612zM5.206.174h1.67c.363 0 .657.274.657.612v.305c0 .339-.295.612-.658.612H5.206c-.363 0-.658-.273-.658-.612V.786c0-.338.295-.612.658-.612z"}})])
          )
        }
      }
    